import router from '@/router';
import userService from '@/service/userService';

const auth = {
  namespaced: true,
  state: {
    token: localStorage.getItem('token') || null,
    username: localStorage.getItem('username') || null,
    role: localStorage.getItem('role') || null,
  },
  actions: {
    async login({ commit }, credentials) {
      const result = await userService.signIn(credentials);
      const token = result.token;
      const username = result.username;
      const role = result.role;

      localStorage.setItem('token', token);
      localStorage.setItem('role', role);
      localStorage.setItem('username', username);

      commit('SET_TOKEN', token);
      commit('SET_USERNAME', username);
      commit('SET_ROLE', role);
      router.push('/');
    },
    logout({ commit }) {
      localStorage.clear();
      commit('SET_TOKEN', null);
      commit('SET_USERNAME', null);
      commit('SET_ROLE', null);
      router.push('/login');
    },
    // 페이지 새로고침시 localStorage의 데이터로 상태를 복원하는 액션 추가
    initializeStore({ commit }) {
      const token = localStorage.getItem('token');
      const username = localStorage.getItem('username');
      const role = localStorage.getItem('role');

      if (token) {
        commit('SET_TOKEN', token);
        commit('SET_USERNAME', username);
        commit('SET_ROLE', role);
      }
    },
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_USERNAME(state, username) {
      state.username = username;
    },
    SET_ROLE(state, role) {
      state.role = role;
    },
  },
  getters: {
    isAuthenticated: state => !!state.token,
    isAdmin: state => state.role === 'ROLE_HYUK',
    isBasic: state => state.role === 'ROLE_BASIC',
    isVip: state => state.role === 'ROLE_HSH',
    username: state => state.username || '',
  },
};

export default auth;
